import ResourceManager, { ResourceType } from "../../components/ResourceManager/ResourceManager"
import { useCalendarEventMutations } from "../hooks/use-calendar-event-mutations"
import { useI18n } from "../../hooks/use-i18n"
import { StringMap } from "../../types/common"
import { CalendarEventViewModel } from "../api/calendar-event"
import { CalendarEventProjectResponse } from "../api/calendar-event-response"

const EventProjectWidget = ({ calendarEvent, projectOptions }: Props) => {
  const { updateProject } = useCalendarEventMutations()
  const translations = useTranslations(defaultTranslations)

  const project: ResourceType[] = calendarEvent.project
    ? [{ id: calendarEvent.project.id, name: calendarEvent.project.title }]
    : []

  const onAddProject = (projectId: string) => {
    const project = projectOptions.find((p) => p.id === projectId)
    if (!project) return
    updateProject(calendarEvent.id, { id: project.id, title: project.name } as CalendarEventProjectResponse)
  }

  const onRemoveProject = () => {
    updateProject(calendarEvent.id, null)
  }

  return (
    <ResourceManager
      title={translations.title}
      resourceOptions={projectOptions}
      resources={project}
      canAddResource={calendarEvent.canUpdate}
      canRemoveResource={calendarEvent.canUpdate}
      onAddResource={onAddProject}
      onRemoveResource={onRemoveProject}
      emptyOptionsMessage={translations.emptyOptionsMessage}
      emptyResourcesMessage={translations.emptyResourcesMessage}
      isMultipleSelection={false}
    />
  )
}

const useTranslations = (defaults = defaultTranslations) => {
  const { translations: t } = useI18n("calendarEvent")
  const translations = (t?.projectWidget || {}) as StringMap

  const {
    title = defaults.title,
    emptyOptionsMessage = defaults.emptyOptionsMessage,
    emptyResourcesMessage = defaults.emptyResourcesMessage,
    updateErrorMessage = defaults.updateErrorMessage,
  } = translations

  return {
    title,
    emptyOptionsMessage,
    emptyResourcesMessage,
    updateErrorMessage,
  }
}

const defaultTranslations = {
  title: "Project",
  emptyOptionsMessage: "No projects to connect this event",
  emptyResourcesMessage: "This event is not connected to any project",
  updateErrorMessage: "Failed to update project",
}

type Props = {
  calendarEvent: CalendarEventViewModel
  projectOptions: ResourceType[]
}
export default EventProjectWidget
